export default {
      id: "icon_stats_shrink_cards-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#icon_stats_shrink_cards-usage",
      toString: function () {
        return this.url;
      }
    }